import { observer } from "mobx-react"

import uiStore from "@src/app/uiStore"

export const DepositEmptyHistory = observer(() => {
  const { isTransferioTheme } = uiStore()

  return isTransferioTheme ? (
    <svg
      fill="none"
      height="109"
      viewBox="0 0 137 109"
      width="137"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2381_17781)">
        <path
          d="M59.9724 27.6297L2.43945 35.3008L0.521685 23.2712C0.103263 16.7159 5.81007 13.4499 8.71577 12.6363L37.8309 8.80078L59.9724 27.6297Z"
          fill="url(#paint0_linear_2381_17781)"
        />
      </g>
      <g filter="url(#filter1_b_2381_17781)">
        <path
          d="M21.9658 26.583L28.9113 77.7272C30.6666 90.6525 33.3382 108.684 46.3736 108.21C46.5573 108.204 46.732 108.192 46.8967 108.175L100.42 101.55C98.1868 101.55 96.2109 101.156 94.4778 100.505C85.5379 97.1451 84.0308 85.8162 82.6368 76.3682C79.2752 53.5847 74.7025 22.727 73.5711 15.5995C72.1764 6.81262 62.9944 5.54574 58.5777 6.01065L10.4592 12.6357C19.1066 14.5883 21.7333 22.7475 21.9658 26.583Z"
          fill="#F8F8F8"
        />
      </g>
      <path
        clip-rule="evenodd"
        d="M72.3008 29.2427C72.5199 30.7677 71.4613 32.1815 69.9363 32.4006L39.6008 36.7591C38.0759 36.9782 36.662 35.9196 36.4429 34.3947C36.2239 32.8698 37.2824 31.456 38.8074 31.2369L69.1429 26.8783C70.6678 26.6592 72.0817 27.7178 72.3008 29.2427ZM34.6573 34.7665C34.8106 36.2994 33.6922 37.6664 32.1593 37.8197L30.4158 37.994C28.8829 38.1473 27.5159 37.0289 27.3626 35.496C27.2093 33.963 28.3278 32.5961 29.8607 32.4428L31.6041 32.2684C33.1371 32.1151 34.504 33.2336 34.6573 34.7665Z"
        fill="#223973"
        fill-rule="evenodd"
        opacity="0.6"
      />
      <path
        clip-rule="evenodd"
        d="M74.5673 39.8775C74.7864 41.4024 73.7278 42.8162 72.2029 43.0353L41.8673 47.3939C40.3424 47.613 38.9286 46.5544 38.7095 45.0295C38.4904 43.5046 39.549 42.0907 41.0739 41.8716L71.4095 37.5131C72.9344 37.294 74.3482 38.3526 74.5673 39.8775ZM36.9239 45.4013C37.0772 46.9342 35.9588 48.3012 34.4258 48.4545L32.6824 48.6288C31.1495 48.7821 29.7825 47.6637 29.6292 46.1307C29.4759 44.5978 30.5943 43.2308 32.1273 43.0775L33.8707 42.9032C35.4036 42.7499 36.7706 43.8683 36.9239 45.4013Z"
        fill="#223973"
        fill-rule="evenodd"
        opacity="0.6"
      />
      <path
        clip-rule="evenodd"
        d="M75.6133 51.733C75.8324 53.2579 74.7738 54.6717 73.2489 54.8908L42.9133 59.2494C41.3884 59.4685 39.9746 58.4099 39.7555 56.8849C39.5364 55.36 40.595 53.9462 42.1199 53.7271L72.4555 49.3686C73.9804 49.1495 75.3942 50.208 75.6133 51.733ZM37.9699 57.2567C38.1232 58.7897 37.0047 60.1566 35.4718 60.3099L33.7284 60.4843C32.1954 60.6376 30.8285 59.5191 30.6752 57.9862C30.5219 56.4533 31.6403 55.0863 33.1733 54.933L34.9167 54.7587C36.4496 54.6054 37.8166 55.7238 37.9699 57.2567Z"
        fill="#223973"
        fill-rule="evenodd"
        opacity="0.6"
      />
      <path
        clip-rule="evenodd"
        d="M77.0079 62.1919C77.2271 63.7169 76.1685 65.1307 74.6435 65.3498L44.308 69.7083C42.7831 69.9274 41.3692 68.8689 41.1501 67.3439C40.931 65.819 41.9896 64.4052 43.5146 64.1861L73.8501 59.8275C75.375 59.6084 76.7889 60.667 77.0079 62.1919ZM39.3645 67.7157C39.5178 69.2486 38.3994 70.6156 36.8665 70.7689L35.123 70.9432C33.5901 71.0965 32.2231 69.9781 32.0698 68.4452C31.9165 66.9122 33.035 65.5453 34.5679 65.392L36.3113 65.2176C37.8443 65.0643 39.2112 66.1828 39.3645 67.7157Z"
        fill="#223973"
        fill-rule="evenodd"
        opacity="0.6"
      />
      <path
        clip-rule="evenodd"
        d="M36.8399 107.817C45.695 107.817 52.8733 100.639 52.8733 91.7834C52.8733 82.9284 45.6949 75.75 36.8399 75.75C27.9848 75.75 20.8064 82.9284 20.8064 91.7834C20.8064 100.639 27.9848 107.817 36.8399 107.817Z"
        fill="#223973"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M35.9028 96.0674L36.9442 92.1459L39.4098 91.2452L40.0231 88.9406L40.0022 88.8834L37.5751 89.7701L39.3238 83.1855H34.3645L32.0776 91.7785L30.1683 92.476L29.5373 94.8519L31.4453 94.155L30.0974 99.2192H43.2962L44.1423 96.0674H35.9028Z"
        fill="#F7F9FB"
        fill-rule="evenodd"
      />
      <g filter="url(#filter2_d_2381_17781)">
        <path
          d="M90.2862 51.2567C99.2408 51.2567 106.5 44.0756 106.5 35.2172C106.5 26.3589 99.2408 19.1777 90.2862 19.1777C81.3315 19.1777 74.0724 26.3589 74.0724 35.2172C74.0724 44.0756 81.3315 51.2567 90.2862 51.2567Z"
          fill="#CBD6F1"
        />
      </g>
      <path
        d="M90.6308 23.541L90.4649 24.0823V39.7872L90.6308 39.9462L98.2233 35.6371L90.6308 23.541Z"
        fill="#223973"
      />
      <path
        d="M90.6309 23.541L83.0382 35.6371L90.6309 39.9462V32.3235V23.541Z"
        fill="#223973"
      />
      <path
        d="M90.6308 41.3264L90.5373 41.4359V47.0303L90.6308 47.2925L98.2279 37.0195L90.6308 41.3264Z"
        fill="#223973"
      />
      <path
        d="M90.6308 47.2925V41.3264L83.0382 37.0195L90.6308 47.2925Z"
        fill="#223973"
      />
      <path
        d="M90.6308 39.947L98.2233 35.6378L90.6308 32.3242V39.947Z"
        fill="#223973"
      />
      <path
        d="M83.0382 35.6378L90.6308 39.947V32.3242L83.0382 35.6378Z"
        fill="#223973"
      />
      <path
        d="M47.7845 20.1364C45.6187 28.8224 36.8202 34.1086 28.1323 31.9426C19.4478 29.777 14.161 20.979 16.3278 12.2934C18.4926 3.60636 27.2911 -1.68036 35.9765 0.485197C44.664 2.65076 49.9503 11.4498 47.7845 20.1364Z"
        fill="#223973"
      />
      <path
        d="M39.205 13.9028C39.5277 11.7453 37.8851 10.5855 35.639 9.81185L36.3676 6.8893L34.5886 6.44596L33.8793 9.29148C33.4116 9.17495 32.9312 9.065 32.454 8.95606L33.1684 6.09178L31.3904 5.64844L30.6613 8.56997C30.2742 8.4818 29.8942 8.39466 29.5253 8.30295L29.5274 8.29383L27.074 7.68125L26.6008 9.58131C26.6008 9.58131 27.9207 9.88379 27.8928 9.90254C28.6133 10.0824 28.7435 10.5592 28.7217 10.9372L27.8918 14.2666C27.9414 14.2793 28.0058 14.2975 28.0767 14.3259C28.0174 14.3112 27.9541 14.295 27.8887 14.2793L26.7254 18.9433C26.6372 19.1622 26.4138 19.4905 25.9102 19.3658C25.9279 19.3917 24.6171 19.0431 24.6171 19.0431L23.734 21.0794L26.049 21.6566C26.4797 21.7645 26.9017 21.8775 27.3172 21.9839L26.581 24.9399L28.3579 25.3832L29.087 22.4586C29.5725 22.5904 30.0437 22.712 30.5047 22.8265L29.7782 25.7374L31.5571 26.1807L32.2933 23.2303C35.3268 23.8044 37.6079 23.5728 38.5681 20.8291C39.3418 18.62 38.5296 17.3457 36.9335 16.5147C38.0959 16.2467 38.9714 15.4821 39.205 13.9028ZM35.1404 19.6025C34.5906 21.8116 30.8711 20.6173 29.6652 20.3179L30.6421 16.4018C31.848 16.7027 35.715 17.2986 35.1404 19.6025ZM35.6906 13.8709C35.189 15.8804 32.0932 14.8594 31.089 14.6091L31.9746 11.0573C32.9789 11.3076 36.213 11.7747 35.6906 13.8709Z"
        fill="white"
      />
      <defs>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="126.5"
          id="filter0_b_2381_17781"
          width="159.473"
          x="-49.5001"
          y="-41.1992"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2381_17781"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2381_17781"
            mode="normal"
            result="shape"
          />
        </filter>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="202.291"
          id="filter1_b_2381_17781"
          width="189.961"
          x="-39.5408"
          y="-44.0723"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2381_17781"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2381_17781"
            mode="normal"
            result="shape"
          />
        </filter>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="92.0781"
          id="filter2_d_2381_17781"
          width="92.4277"
          x="44.0724"
          y="4.17773"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="15" />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_2381_17781"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_2381_17781"
            mode="normal"
            result="shape"
          />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2381_17781"
          x1="7.12488"
          x2="37.8091"
          y1="23.537"
          y2="12.9021"
        >
          <stop stop-color="#E0E7FF" />
          <stop offset="1" stop-color="#C0CEF0" />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg
      fill="none"
      height="109"
      viewBox="0 0 136 109"
      width="136"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_1420_11600)">
        <path
          d="M59.4725 27.629L1.93957 35.3L0.0218068 23.2704C-0.396615 16.7152 5.31019 13.4491 8.21589 12.6355L37.3311 8.80002L59.4725 27.629Z"
          fill="url(#paint0_linear_1420_11600)"
        />
      </g>
      <g filter="url(#filter1_b_1420_11600)">
        <path
          d="M21.4658 26.5829L28.4113 77.7271C30.1666 90.6524 32.8382 108.683 45.8736 108.21C46.0573 108.203 46.232 108.192 46.3968 108.175L99.9198 101.55C97.6868 101.55 95.7109 101.156 93.9779 100.505C85.038 97.145 83.5308 85.8161 82.1368 76.3681C78.7752 53.5846 74.2025 22.7269 73.0711 15.5994C71.6764 6.81252 62.4944 5.54563 58.0777 6.01054L9.95923 12.6355C18.6066 14.5882 21.2334 22.7474 21.4658 26.5829Z"
          fill="#F8F8F8"
        />
      </g>
      <path
        clipRule="evenodd"
        d="M71.8008 29.2418C72.0199 30.7667 70.9613 32.1806 69.4364 32.3997L39.1008 36.7582C37.5759 36.9773 36.1621 35.9187 35.943 34.3938C35.7239 32.8689 36.7825 31.4551 38.3074 31.236L68.643 26.8774C70.1679 26.6583 71.5817 27.7169 71.8008 29.2418ZM34.1574 34.7656C34.3107 36.2985 33.1922 37.6655 31.6593 37.8188L29.9159 37.9931C28.3829 38.1464 27.016 37.028 26.8627 35.495C26.7094 33.9621 27.8278 32.5951 29.3608 32.4418L31.1042 32.2675C32.6371 32.1142 34.0041 33.2326 34.1574 34.7656Z"
        fill="#1C6C2A"
        fillRule="evenodd"
        opacity="0.6"
      />
      <path
        clipRule="evenodd"
        d="M74.0674 39.8767C74.2865 41.4016 73.2279 42.8154 71.703 43.0345L41.3674 47.3931C39.8425 47.6122 38.4287 46.5536 38.2096 45.0287C37.9905 43.5038 39.0491 42.0899 40.574 41.8709L70.9096 37.5123C72.4345 37.2932 73.8483 38.3518 74.0674 39.8767ZM36.424 45.4005C36.5773 46.9334 35.4588 48.3004 33.9259 48.4537L32.1825 48.628C30.6495 48.7813 29.2826 47.6629 29.1293 46.1299C28.976 44.597 30.0944 43.23 31.6274 43.0767L33.3708 42.9024C34.9037 42.7491 36.2707 43.8675 36.424 45.4005Z"
        fill="#1C6C2A"
        fillRule="evenodd"
        opacity="0.6"
      />
      <path
        clip-rule="evenodd"
        d="M75.1133 51.732C75.3324 53.2569 74.2738 54.6707 72.7489 54.8898L42.4133 59.2484C40.8884 59.4675 39.4746 58.4089 39.2555 56.884C39.0364 55.359 40.095 53.9452 41.6199 53.7261L71.9555 49.3676C73.4804 49.1485 74.8942 50.207 75.1133 51.732ZM37.4699 57.2557C37.6232 58.7887 36.5047 60.1556 34.9718 60.3089L33.2284 60.4833C31.6954 60.6366 30.3285 59.5181 30.1752 57.9852C30.0219 56.4523 31.1403 55.0853 32.6733 54.932L34.4167 54.7577C35.9496 54.6044 37.3166 55.7228 37.4699 57.2557Z"
        fill="#1C6C2A"
        fill-rule="evenodd"
        opacity="0.6"
      />
      <path
        clip-rule="evenodd"
        d="M76.5081 62.1925C76.7272 63.7174 75.6686 65.1312 74.1437 65.3503L43.8081 69.7089C42.2832 69.928 40.8694 68.8694 40.6503 67.3445C40.4312 65.8196 41.4898 64.4057 43.0147 64.1866L73.3502 59.8281C74.8752 59.609 76.289 60.6676 76.5081 62.1925ZM38.8646 67.7163C39.0179 69.2492 37.8995 70.6162 36.3666 70.7695L34.6232 70.9438C33.0902 71.0971 31.7233 69.9787 31.57 68.4457C31.4167 66.9128 32.5351 65.5458 34.068 65.3925L35.8115 65.2182C37.3444 65.0649 38.7114 66.1833 38.8646 67.7163Z"
        fill="#1C6C2A"
        fill-rule="evenodd"
        opacity="0.6"
      />
      <path
        clip-rule="evenodd"
        d="M36.3399 107.817C45.195 107.817 52.3733 100.638 52.3733 91.7833C52.3733 82.9283 45.1949 75.7499 36.3399 75.7499C27.4848 75.7499 20.3064 82.9283 20.3064 91.7833C20.3064 100.638 27.4848 107.817 36.3399 107.817Z"
        fill="#00E69A"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M35.4028 96.0665L36.4442 92.1451L38.9098 91.2443L39.5231 88.9397L39.5022 88.8826L37.0752 89.7692L38.8238 83.1847H33.8645L31.5776 91.7776L29.6683 92.4752L29.0374 94.8511L30.9453 94.1541L29.5975 99.2183H42.7962L43.6423 96.0665H35.4028Z"
        fill="#F7F9FB"
        fill-rule="evenodd"
      />
      <g filter="url(#filter2_d_1420_11600)">
        <path
          d="M89.7861 51.2566C98.7408 51.2566 106 44.0755 106 35.2171C106 26.3588 98.7408 19.1776 89.7861 19.1776C80.8314 19.1776 73.5723 26.3588 73.5723 35.2171C73.5723 44.0755 80.8314 51.2566 89.7861 51.2566Z"
          fill="#EBFCF5"
        />
      </g>
      <path
        d="M90.1308 23.5402L89.9648 24.0814V39.7864L90.1308 39.9453L97.7233 35.6362L90.1308 23.5402Z"
        fill="#1C6C2A"
      />
      <path
        d="M90.1307 23.5401L82.5381 35.6362L90.1307 39.9453V32.3226V23.5401Z"
        fill="#26A17B"
      />
      <path
        d="M90.1306 41.3256L90.0371 41.4351V47.0294L90.1306 47.2916L97.7277 37.0187L90.1306 41.3256Z"
        fill="#26A17B"
      />
      <path
        d="M90.1307 47.2916V41.3256L82.5381 37.0187L90.1307 47.2916Z"
        fill="#26A17B"
      />
      <path
        d="M90.1306 39.9453L97.7231 35.6362L90.1306 32.3226V39.9453Z"
        fill="#1C6C2A"
      />
      <path
        d="M82.5381 35.6362L90.1307 39.9453V32.3226L82.5381 35.6362Z"
        fill="#1C6C2A"
      />
      <path
        d="M47.2846 20.1364C45.1188 28.8224 36.3204 34.1086 27.6324 31.9426C18.9479 29.777 13.6612 20.979 15.828 12.2934C17.9927 3.60636 26.7912 -1.68036 35.4767 0.485197C44.1642 2.65076 49.4504 11.4498 47.2846 20.1364Z"
        fill="#00E69A"
      />
      <path
        d="M38.7052 13.9038C39.0279 11.7463 37.3853 10.5865 35.1391 9.81281L35.8677 6.89026L34.0888 6.44692L33.3794 9.29244C32.9118 9.17591 32.4314 9.06596 31.9541 8.95702L32.6686 6.09275L30.8906 5.6494L30.1615 8.57093C29.7744 8.48277 29.3944 8.39562 29.0255 8.30391L29.0275 8.29479L26.5742 7.68221L26.1009 9.58227C26.1009 9.58227 27.4208 9.88476 27.393 9.9035C28.1135 10.0834 28.2437 10.5602 28.2219 10.9381L27.392 14.2676C27.4416 14.2802 27.506 14.2985 27.5769 14.3268C27.5176 14.3121 27.4543 14.2959 27.3889 14.2802L26.2256 18.9442C26.1374 19.1631 25.914 19.4915 25.4103 19.3668C25.4281 19.3926 24.1173 19.0441 24.1173 19.0441L23.2341 21.0804L25.5492 21.6575C25.9798 21.7654 26.4019 21.8784 26.8174 21.9848L26.0812 24.9408L27.8581 25.3842L28.5872 22.4596C29.0726 22.5913 29.5438 22.7129 30.0049 22.8274L29.2783 25.7383L31.0573 26.1817L31.7935 23.2313C34.827 23.8053 37.1081 23.5738 38.0683 20.8301C38.842 18.621 38.0298 17.3467 36.4337 16.5157C37.596 16.2477 38.4716 15.4831 38.7052 13.9038ZM34.6406 19.6034C34.0908 21.8126 30.3713 20.6183 29.1654 20.3189L30.1422 16.4027C31.3481 16.7037 35.2151 17.2995 34.6406 19.6034ZM35.1908 13.8718C34.6892 15.8813 31.5934 14.8604 30.5891 14.6101L31.4748 11.0582C32.4791 11.3085 35.7132 11.7757 35.1908 13.8718Z"
        fill="#ECECEC"
      />
      <defs>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="126.5"
          id="filter0_b_1420_11600"
          width="159.472"
          x="-50"
          y="-41.2"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1420_11600"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1420_11600"
            mode="normal"
            result="shape"
          />
        </filter>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="202.292"
          id="filter1_b_1420_11600"
          width="189.961"
          x="-40.0408"
          y="-44.0724"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1420_11600"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1420_11600"
            mode="normal"
            result="shape"
          />
        </filter>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="92.079"
          id="filter2_d_1420_11600"
          width="92.4277"
          x="43.5723"
          y="4.17764"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="15" />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_1420_11600"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1420_11600"
            mode="normal"
            result="shape"
          />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_1420_11600"
          x1="6.62501"
          x2="37.3092"
          y1="23.5362"
          y2="12.9013"
        >
          <stop stop-color="#EBFCF5" />
          <stop offset="1" stop-color="#CDDCD6" />
        </linearGradient>
      </defs>
    </svg>
  )
})
